const session = {
    namespaced: false,
    state: () => ({
        appName: undefined,
        appIcon: undefined,
        siteId: undefined,
        checkId: undefined,
        expirationTicks: undefined,
        accountId: undefined,
        siteNumber: undefined, 
        checkNumber: undefined,
        businessDate: undefined,
        checkOpenDateTime: undefined,
        checkTotal: undefined,
        showLoadingSpinner: false,
        showLoadingBlocker: false,
        showLoadingMessage: false,
        loadingMessage: undefined,
        check: null,
        tip: 0,
        tempTip: 0, // Used to display unconfirmed tip in Tip view.
        selectedTipOption: null,
        isCheckDetailsShown: true,
        payment: null,
        googlePayScriptLoaded: false,
        brainTreeGooglePayComponent: null,
        googlePaymentClient: null,
        creditCardInitCompleted: false,
        creditCardPaymentClient: null,
        spriteImagesReady: false,
        paymentProcessor: undefined,
        paymentId: undefined,
        paymentMethod: 0
    }),
    mutations: {
        setSessionIds(state, payload) {
            state.siteId = payload.siteId;
            state.checkId = payload.checkId;
            state.expirationTicks = payload.expirationTicks;
            state.accountId = payload.accountId;
            state.siteNumber = payload.siteNumber;
            state.checkNumber = payload.checkNumber;
            state.businessDate = payload.businessDate;
            state.checkOpenDateTime = payload.checkOpenDateTime;
            state.checkTotal = payload.checkTotal;
            state.paymentId = payload.paymentId;
            state.paymentMethod = payload.paymentMethod;
        },
        setLoadingStatus(state, value) {
            if (typeof value === "boolean") {
                state.showLoadingSpinner = value;
                state.showLoadingBlocker = value;
                state.showLoadingMessage = false;
                state.loadingMessage = undefined;
            }
            else {
                state.showLoadingSpinner = value.showSpinner;
                state.showLoadingBlocker = value.showBlocker;
                state.showLoadingMessage = value.showMessage;
                state.loadingMessage = value.loadingMessage;
            }
        },
        set(state, value) {
            state.check = value;
        },
        setTip(state, payload) {
            state.tip = payload.tip;
            state.selectedTipOption = payload.selectedTipOption;
        },
        setTempTip(state, value) {
            state.tempTip = value;
        },
        setIsCheckDetailsShown(state, value) {
            state.isCheckDetailsShown = value;
        },
        setPayment(state, value) {
            state.payment = value;
            state.check.payments.push(value);

            // 1 is "Approved" status.
            if (value.paymentStatus === 1) {
                state.check.balance -= state.payment.amount;
            }
        },
        updatePayment(state, value) {
            state.payment = value;
        },
        setGooglePayScriptLoaded(state, value) {
            state.googlePayScriptLoaded = value;
        },
        setBrainTreeGooglePayComponent(state, value) {
            state.brainTreeGooglePayComponent = value;
        },
        setGooglePaymentClient(state, value) {
            state.googlePaymentClient = value;
        },
        setCreditCardPaymentClient(state, payload) {
            state.creditCardInitCompleted = payload.creditCardInitCompleted;
            state.creditCardPaymentClient = payload.creditCardPaymentClient;
        },
        setSpriteImagesReady(state, value) {
            state.spriteImagesReady = value;
        },
        setCustomization(state, payload) {
            state.appName = payload.appName;
            state.appIcon = payload.appIcon;
        },
        setProcessor(state, value) {
            state.paymentProcessor = value;
        }
    },
    getters: {
        tipTotal: state => {
            if (state.check == null || state.check.payments == null) {
                return 0;
            }

            // 1 is "Approved" status.
            return state.check.payments
                .filter(item => item.paymentStatus === 1)
                .reduce((accum, item) => accum + item.tip, 0);
        },
        taxTotal: state => {
            if (state.check == null) {
                return 0;
            }

            let orderItemsTaxTotal = 0;

            if (state.check.orderItems !== null) {
                orderItemsTaxTotal = state.check.orderItems
                    .reduce((accum, item) => accum + item.tax, 0);
            }

            return orderItemsTaxTotal + state.check.gratuityTaxTotal;
        },
        total: (state, getters) => {
            if (state.check == null) {
                return 0;
            }

            return state.check.subTotal + (state.check.gratuityTotal - state.check.gratuityTaxTotal)
                + getters.taxTotal - Math.abs(state.check.taxExempt);
        },
        // NorthStar pay has different meaning for balance. The value displayed on the views
        // (excluding Payment screen) includes the tip.
        balanceWithTip: state => {
            if (state.check == null) {
                return 0;
            }

            return state.check.balance + state.tip;
        },
        balanceWithTempTip: state => {
            if (state.check == null) {
                return 0;
            }

            return state.check.balance + state.tempTip;
        },
        balance: state => {
            if (state.check == null) {
                return 0;
            }

            // In payments summary, tip shouldn't be included in balance.
            return state.check.balance;
        }
    }
}

export default session;